import { defineComponent, computed, openBlock, createElementBlock, mergeProps, unref, createCommentVNode, renderSlot, normalizeStyle, createBlock, resolveDynamicComponent } from 'vue';
import { APPEARANCE, SIZE } from '@omnica/link';
import { componentExists } from '@omnica/base-vue3';

const _hoisted_1 = ["href", "target"];
const _hoisted_2 = {
    key: 0,
    class: "omnica-link__inner"
};
var script = /*#__PURE__*/ defineComponent({
    __name: 'UiLink',
    props: {
        /** Атрибут ссылки */
        href: {
            type: String,
            default: 'javascript:void(0);',
        },
        /**
         * Определяет, нужно ли открывать ссылку в новой вкладке.
         * Также добавляется иконка внешней ссылки (если компонент UiIcon установлен)
         */
        external: {
            type: Boolean,
            default: false,
        },
        /** Тип ссылок */
        appearance: {
            type: String,
            validator: (appearance) => Object.values(APPEARANCE).includes(appearance),
            default: APPEARANCE.DEFAULT,
        },
        /**
         * Размер шрифта
         * Возможные значения совпадают с токенами для параметров шрифта
         * (tiny, small, body, paragraph, article, title-02, title-01)
         */
        size: {
            type: String,
            validator: (size) => Object.values(SIZE).includes(size),
            default: SIZE.BODY,
        },
        /** Инвертированный цвет ссылок для тёмного фона */
        light: {
            type: Boolean,
            default: false,
        },
        /** Жирное начертание */
        accent: {
            type: Boolean,
            default: false,
        },
        /** Смещение иконки от текста */
        iconOffset: {
            type: [String, Number],
            default: 2,
        },
        /** Подчеркивание dotted вместо стандартного поведения */
        dotBorder: {
            type: Boolean,
            default: false,
        },
        /** Определяет, будет ли текст ошибок обрезаться через многоточие или переноситься на следующую строку */
        ellipsis: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        const props = __props;
        const hasIconComponent = componentExists('UiIcon');
        const target = computed(() => props.external ? '_blank' : null);
        return (_ctx, _cache) => {
            return (openBlock(), createElementBlock("a", mergeProps(Object.assign({}, _ctx.$attrs), {
                href: __props.href,
                class: {
                    ['omnica-link']: true,
                    [`omnica-link_${__props.appearance}`]: true,
                    [`omnica-link_${__props.size}`]: true,
                    [`omnica-link_dark`]: !__props.light,
                    [`omnica-link_light`]: __props.light,
                    [`omnica-link_accent`]: __props.accent,
                    [`omnica-link_dot-border`]: __props.dotBorder,
                    [`omnica-link_ellipsis`]: __props.ellipsis
                },
                target: unref(target)
            }), [
                (__props.dotBorder)
                    ? (openBlock(), createElementBlock("span", _hoisted_2, [
                        createCommentVNode(" @slot Текст ссылки "),
                        renderSlot(_ctx.$slots, "default")
                    ]))
                    : renderSlot(_ctx.$slots, "default", { key: 1 }),
                (_ctx.$slots.icon || __props.external)
                    ? (openBlock(), createElementBlock("span", {
                        key: 2,
                        class: "omnica-link__icon",
                        style: normalizeStyle(`margin-left: ${__props.iconOffset}px;`)
                    }, [
                        createCommentVNode(" @slot Слот для иконки "),
                        renderSlot(_ctx.$slots, "icon", {}, () => [
                            (unref(hasIconComponent))
                                ? (openBlock(), createBlock(resolveDynamicComponent('UiIcon'), {
                                    key: 0,
                                    name: "open-in-new"
                                }))
                                : createCommentVNode("v-if", true)
                        ])
                    ], 4 /* STYLE */))
                    : createCommentVNode("v-if", true)
            ], 16 /* FULL_PROPS */, _hoisted_1));
        };
    }
});

script.__file = "packages/link/src/UiLink.vue";

export { script as default };
